// src/component/index.ts
var SvpMostSeenInterval = /* @__PURE__ */ ((SvpMostSeenInterval2) => {
  SvpMostSeenInterval2["LAST_HOUR"] = "hour";
  SvpMostSeenInterval2["LAST_DAY"] = "day";
  SvpMostSeenInterval2["LAST_WEEK"] = "week";
  SvpMostSeenInterval2["LAST_MONTH"] = "month";
  return SvpMostSeenInterval2;
})(SvpMostSeenInterval || {});
var DataType = /* @__PURE__ */ ((DataType2) => {
  DataType2["ASSETS"] = "assets";
  DataType2["MIXED"] = "mixed";
  DataType2["SEASONS"] = "seasons";
  DataType2["CATEGORIES"] = "categories";
  DataType2["PROFILES"] = "profiles";
  DataType2["STAYLIVE_STREAMS"] = "staylive/streams";
  DataType2["STORIES"] = "stories";
  return DataType2;
})(DataType || {});
var ComponentType = /* @__PURE__ */ ((ComponentType2) => {
  ComponentType2["LIST"] = "list";
  ComponentType2["SLIDER"] = "slider";
  ComponentType2["EDITORIAL"] = "editorial";
  ComponentType2["SPLASH"] = "splash";
  ComponentType2["CAROUSEL"] = "carousel";
  ComponentType2["FILTERED_LIST"] = "filtered-list";
  ComponentType2["LIVE_ASSETS_SCHEDULE"] = "scheduled";
  ComponentType2["CONTINUE_WATCHING"] = "continue-watching";
  return ComponentType2;
})(ComponentType || {});
var CategoryDataSource = /* @__PURE__ */ ((CategoryDataSource2) => {
  CategoryDataSource2["SVP_CATEGORIES"] = "svp/categories";
  return CategoryDataSource2;
})(CategoryDataSource || {});
var AssetDataSource = /* @__PURE__ */ ((AssetDataSource2) => {
  AssetDataSource2["SVP_ASSETS"] = "svp/assets";
  AssetDataSource2["SVP_SEARCH"] = "svp/search";
  AssetDataSource2["SVP_MOST_SEEN"] = "svp/most-seen";
  AssetDataSource2["SVP_EPISODES"] = "svp/episodes";
  AssetDataSource2["CURATE_BLEND"] = "curate/blend";
  return AssetDataSource2;
})(AssetDataSource || {});
var StayLiveSource = /* @__PURE__ */ ((StayLiveSource2) => {
  StayLiveSource2["STAYLIVE_CHANNEL"] = "staylive/channel";
  return StayLiveSource2;
})(StayLiveSource || {});
var ProfileSource = /* @__PURE__ */ ((ProfileSource2) => {
  ProfileSource2["PROFILES"] = "/profiles";
  return ProfileSource2;
})(ProfileSource || {});
var Layout = /* @__PURE__ */ ((Layout2) => {
  Layout2["VERTICAL"] = "vertical";
  Layout2["HORIZONTAL"] = "horizontal";
  return Layout2;
})(Layout || {});
var StreamType = /* @__PURE__ */ ((StreamType2) => {
  StreamType2["VOD"] = "vod";
  StreamType2["LIVE"] = "live";
  StreamType2["WAS_LIVE"] = "wasLive";
  return StreamType2;
})(StreamType || {});
var PaywallAccess = /* @__PURE__ */ ((PaywallAccess2) => {
  PaywallAccess2["PLUS_AND_SPORT"] = "plus,sport";
  return PaywallAccess2;
})(PaywallAccess || {});
var getComponent = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/components/${id}`, options).json();
};
var createComponent = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/components`, { json: data, ...options }).json();
};
var updateComponent = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/components/${id}`, { json: data, ...options }).json();
};
var getSharedComponents = (client, provider) => async (options) => {
  return await client.get(`${provider}/components/shared`, options).json();
};
var getComponentSettings = (client, provider) => async (options) => {
  return await client.get(`${provider}/components/settings`, options).json();
};
var createComponentApi = (client, provider) => {
  return {
    getComponent: getComponent(client, provider),
    createComponent: createComponent(client, provider),
    updateComponent: updateComponent(client, provider),
    getSharedComponents: getSharedComponents(client, provider),
    getComponentSettings: getComponentSettings(client, provider)
  };
};

export {
  SvpMostSeenInterval,
  DataType,
  ComponentType,
  CategoryDataSource,
  AssetDataSource,
  StayLiveSource,
  ProfileSource,
  Layout,
  StreamType,
  PaywallAccess,
  createComponentApi
};
